import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType,
    Widget,
    CodeBlock,
    BlockType,
} from '@appblocks/codegeneration/types';
import BaseWidget, { sizes } from '@appblocks/codegeneration/Widgets/BaseWidget';

export default class LCDImageWidget extends BaseWidget {
    constructor() {
        super();
        this.name = 'Image Widget';
        this.id = 'lcd_image_widget';
        this.minW = sizes[this.id].minW;
        this.minH = sizes[this.id].minH;

        const settings = this.getWidgetSettings(['NAME', 'IMG', 'VISIBLE']);

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];

        if (this.project.runtime === 'simulator') {
            let SCREEN_INDEX = 0;
            const lcd = this.project.getFeature('lcd');
            const screens = lcd.getSettingValue('SCREENS');
            for (let i = 0; i < screens.length; i++) {
                const screen = screens[i];
                const widgets = screen.getSettingValue('WIDGETS');
                for (let j = 0; j < widgets.length; j++) {
                    const widget = widgets[j];
                    if (widget.getID() === this.getID()) {
                        SCREEN_INDEX = i;
                        break;
                    }
                }
            }

            const IMG = this.getSettingValue('IMG');
            const VISIBLE = this.getSettingValue('VISIBLE');
            const X = this.getSettingValue('X');
            const Y = this.getSettingValue('Y');
            const W = this.getSettingValue('W');
            const H = this.getSettingValue('H');

            blocks.push({
                location: 'display_init_widgets',
                blockType: BlockType.CODE,
                template: `
simulator.updateContext("${this.getID()}", {
    IMG: "${IMG}",
    VISIBLE: "${VISIBLE}",
    X: "${X}",
    Y: "${Y}",
    W: "${W}",
    H: "${H}",
    SCREEN_INDEX: ${SCREEN_INDEX},
})
`,
            });
        }

        return blocks;
    }
}
